"use client";

import { motion, useSpring } from "motion/react";
import { useRef } from "react";
import { motionStill } from "@/utils/motion";

export default function TiltCard({
  children,
  maxTilt = 15,
}: {
  children: React.ReactNode;
  maxTilt?: number;
}) {
  const cardRef = useRef<HTMLDivElement>(null);
  const z = useSpring(0);
  const rotateX = useSpring(0);
  const rotateY = useSpring(0);

  const calculateTilt = (event: React.PointerEvent<HTMLDivElement>) => {
    if (!cardRef.current) return { rotateX: 0, rotateY: 0 };

    const rect = cardRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Convert coordinates to percentages
    const xPercent = x / rect.width;
    const yPercent = y / rect.height;

    return {
      rotateX: maxTilt * (0.5 - yPercent),
      rotateY: maxTilt * (xPercent - 0.5),
    };
  };

  return (
    <motion.div
      ref={cardRef}
      style={{
        ...styles.card,
        z,
        rotateX,
        rotateY,
      }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      onPointerMove={(e) => {
        if (motionStill(cardRef.current)) return;
        const tilt = calculateTilt(e);
        rotateX.set(tilt.rotateX);
        rotateY.set(tilt.rotateY);
      }}
      onPointerLeave={() => {
        rotateX.set(0);
        rotateY.set(0);
        z.set(0);
      }}
      onPointerEnter={() => {
        if (motionStill(cardRef.current)) return;
        z.set(-10);
      }}
    >
      {children}
    </motion.div>
  );
}

/**
 * ==============   Styles   ================
 */

const styles = {
  card: {
    position: "relative",
    willChange: "transform",
    transformPerspective: 500,
  },
} as const;
